import Vue from 'vue'
import Router from 'vue-router'

import Login from '../components/authentication/Login'
import LostPassword from '../components/authentication/LostPassword'
import ResetPassword from '../components/authentication/ResetPassword'
import Home from '../components/Home'
import Users from '../components/management/users/dashboard'
import Languages from '../components/configuration/languages/Languages'
import Chronometer from '../components/apps/chronometer/dashboardChronometer'
import SimpleChronometer from '../components/apps/simpleChronometer/dashboardChronometer'
import Matches from '../components/apps/matches/dashboard'
import Tournaments from '../components/apps/tournaments/dashboard'
import notificaciones from '../components/apps/notificaciones/notificaciones'
import Entities from '../components/management/entities/dashboard'
import Centers from '../components/management/centers/dashboard'
import Teams from '../components/management/teams/dashboard'
import AcceptInvitation from '../components/management/teams/AcceptInvitation'
import Acts from '../components/management/acts/dashboard'
import Courses from '../components/management/courses/dashboard'
import Advertisings from '../components/management/advertising/dashboard'
import Categories from '../components/management/categories/dashboard'
import Roles from '../components/management/rols/dashboard'
import Cities from '../components/configuration/location/cities/dashboard'
import Countries from '../components/configuration/location/countries/dashboard'
import Provinces from '../components/configuration/location/provinces/dashboard'
import Profile from '../components/configuration/profile/ProfileView'
import Aspects from '../components/management/aspects/dashboard'
import VideoPlayer from '../components/widgets/video/VideoPlayer'
import YoutubePlayer from '../components/widgets/video/YoutubePlayer'
import tabEvents from '../components/apps/matches/tabEvents'

/* const aspects = () => import('../components/management/aspects/dashboard')
const Profile = () => import ('../components/configuration/profile/ProfileView')
const Provinces = () => import ('../components/configuration/location/provinces/dashboard')
const Countries = () => import ('../components/configuration/location/countries/dashboard')
const Cities = () => import ('../components/configuration/location/cities/dashboard')
const Roles = () => import ('../components/management/rols/dashboard')
const Categories = () => import ('../components/management/categories/dashboard')
const publicidad = () => import ('../components/management/publicidad/publicidad')
const cursos = () => import ('../components/management/cursos/cursos')
const Home = () => import('../components/Home')
const Users = () => import('../components/management/users/dashboard')
const Languages = () => import('../components/configuration/languages/Languages')
const cronometro = () => import('../components/apps/chronometer/dashboardChronometer')
const SimpleChronometer = () => import('../components/apps/simpleChronometer/dashboardChronometer')
const Matches = () => import('../components/apps/matches/dashboard')
const Tournaments = () => import('../components/apps/tournaments/dashboard')
const notificaciones = () => import('../components/apps/notificaciones/notificaciones')
const Entities = () => import('../components/management/entities/dashboard')
const Centers = () => import('../components/management/centers/dashboard')
const Teams = () => import('../components/management/teams/dashboard')
const Acts = () => import('../components/management/acts/dashboard') */

Vue.use(Router)

export const router = new Router({
  // mode: 'history',
  // base: '/',
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/dashboard', name: 'dashboard', component: Home, meta: { requiresAuth: true, breadcrumb: true } },
    { path: '/management/users', name: 'users', component: Users, meta: { requiresAuth: true, breadcrumb: true } },
    { path: '/apps/chronometer', name: 'chronometer', component: Chronometer, meta: { requiresAuth: false, breadcrumb: true } },
    { path: '/apps/simple-chronometer', name: 'simpleChronometer', component: SimpleChronometer, meta: { requiresAuth: false, breadcrumb: true } },

    { path: '/apps/tournaments', name: 'tournaments', component: Tournaments, meta: { requiresAuth: true, breadcrumb: true } },
    {
      path: '/apps/notificaciones',
      name: 'notifications',
      component: notificaciones,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/apps/matches',
      name: 'matches',
      component: Matches,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/management/entities',
      name: 'entities',
      component: Entities,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/management/centers',
      name: 'centers',
      component: Centers,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    /* {
      path: '/management/pitches',
      name: 'pitches',
      component: Pitches,
      meta: {requiresAuth: true, breadcrumb: true}
    }, */
    {
      path: '/management/teams',
      name: 'teams',
      component: Teams,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/teams/acceptInvitation/:teamId/:tournamentId/:tk',
      name: 'acceptInvitation',
      component: AcceptInvitation,
      props: true
    },
    { path: '/managements/acts', name: 'acts', component: Acts, meta: { requiresAuth: true, breadcrumb: true } },
    { path: '/managements/aspects', name: 'aspects', component: Aspects, meta: { requiresAuth: true, breadcrumb: true } },
    { path: '/managements/courses', name: 'courses', component: Courses, meta: { requiresAuth: true, breadcrumb: true } },
    {
      path: '/managements/advertisings',
      name: 'advertisings',
      component: Advertisings,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/managements/categories',
      name: 'categories',
      component: Categories,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    { path: '/managements/roles', name: 'roles', component: Roles, meta: { requiresAuth: true, breadcrumb: true } },
    { path: '/config/cities', name: 'cities', component: Cities, meta: { requiresAuth: true, breadcrumb: true } },
    { path: '/config/countries', name: 'countries', component: Countries, meta: { requiresAuth: true, breadcrumb: true } },
    {
      path: '/config/provinces',
      name: 'provinces',
      component: Provinces,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/config/languages',
      name: 'languages',
      component: Languages,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/config/profile',
      name: 'profile',
      component: Profile,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/video',
      name: 'video',
      component: VideoPlayer,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/youtube',
      name: 'youtube',
      component: YoutubePlayer,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    {
      path: '/tabEvents',
      name: 'tabEvents',
      component: tabEvents,
      meta: { requiresAuth: true, breadcrumb: true }
    },
    // Auth routes
    { path: '/login', name: 'login', component: Login },
    { path: '/lostPassword', name: 'lostPassword', component: LostPassword },
    { path: '/lostPassword/:userId/:tk', name: 'resetPassword', component: ResetPassword, props: true },

    // otherwise redirect to home
    { path: '*', redirect: '/dashboard' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const loggedIn = localStorage.getItem('user')
    if (!loggedIn) {
      return next('login')
    } else {
      next()
    }
  } else {
    next()
  }
})

// router.beforeEach((to, from, next) => {
//   // redirect to login page if not logged in and trying to access a restricted page
//   const publicPages = ['/login'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   if (authRequired && !loggedIn) {
//     return next('/login');
//   }

//   next();
// })
